var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons38PxMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 27.444,
    fill: "#353A48",
    rx: 3.167
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    d: "M17.391.14c4.132 0 7.482 3.392 7.482 7.577 0 4.186-3.35 7.578-7.482 7.578-1.852 0-3.547-.681-4.853-1.81-1.307 1.129-3.002 1.81-4.854 1.81-4.132 0-7.482-3.393-7.482-7.578C.202 3.532 3.552.14 7.684.14c1.852 0 3.547.682 4.854 1.81C13.844.821 15.539.14 17.39.14z",
    transform: "translate(6.876 6.144)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    d: "M7.684.14c1.852 0 3.547.68 4.854 1.81-1.609 1.39-2.63 3.458-2.63 5.767 0 2.31 1.021 4.378 2.63 5.768-1.307 1.129-3.002 1.81-4.854 1.81-4.132 0-7.482-3.393-7.482-7.578C.202 3.532 3.552.14 7.684.14z",
    transform: "translate(6.876 6.144)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    d: "M17.391.14c4.132 0 7.482 3.392 7.482 7.577 0 4.186-3.35 7.578-7.482 7.578-1.852 0-3.547-.681-4.854-1.81 1.61-1.39 2.63-3.458 2.63-5.768 0-2.309-1.02-4.377-2.629-5.767 1.306-1.129 3-1.81 4.853-1.81z",
    transform: "translate(6.876 6.144)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons38PxMastercard);
export default __webpack_public_path__ + "static/media/icons-38-px-mastercard.bc2235d3953831bef1498e374df5aa0a.svg";
export { ForwardRef as ReactComponent };